
import { QueovalDik } from "../global";

export class InfoLienEffectifs{

  public IdPere: string;

  public IdFils: string;

  public IdRelation: string;

  public ListeValue: Array<QueovalDik>;
}
